import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { RouterLink } from 'src/routes/components';

import logoMini from 'src/assets/logo/logo_single.svg';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, src, ...other }, ref) => {
  // OR using local (public folder)
  // -------------------------------------------------------
  const logo = (
    <Box
      component="img"
      src={src ?? logoMini}
      sx={{ width: 40, height: 40, objectFit: 'contain', cursor: 'pointer', ...sx }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
      <Link component={RouterLink} href="/" sx={{display: 'contents'}}>
        {logo}
      </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  src: PropTypes.string
};

export default Logo;
